import { render, staticRenderFns } from "./InstallWebappPopup.vue?vue&type=template&id=005fea22&scoped=true"
import script from "./InstallWebappPopup.vue?vue&type=script&lang=js"
export * from "./InstallWebappPopup.vue?vue&type=script&lang=js"
import style0 from "./InstallWebappPopup.vue?vue&type=style&index=0&id=005fea22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fea22",
  null
  
)

export default component.exports